import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateEvent, UpdateEventParams} from '../api';
import {QUERY__EVENT, QUERY__EVENTS} from '../queryKeys';

export const useUpdateEvent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateEventParams) => updateEvent(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__EVENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY__EVENT],
      });
    },
  });
};
